// Forked from services/caseNote.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import type { IServiceRequestNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createServiceRequestNote,
  updateNote: updateServiceRequestNote,
  deleteNote: deleteServiceRequestNote,
} = makeNoteService<IServiceRequestNote>(
  '/api/servicerequestnotes',
  'serviceRequestNote'
)
